export const TWELVE_TONE_NOTES = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"];


export const MAPPED_INTERVALS_TO_DISPLAY_NAMES = {
    "1P": "Root Note",
    "1A": "Minor 2nd",
    "2M": "Major 2nd",
    "3m": "Minor 3rd",
    "3M": "Major 3rd",
    "4P": "Perfect 4th",
    "4A": "Tritone",
    "5P": "Perfect 5th",
    "6m": "Minor 6th",
    "6M": "Major 6th",
    "7m": "Minor 7th",
    "7M": "Major 7th",
    "9m": "Minor 9th",
    "9M": "Major 9th",
    "10m": "Minor 10th",
    "10M": "Major 10th",
    "11m": "Minor 11th",
    "11M": "Major 11th",
    "13m": "Minor 13th",
    "13M": "Major 13th"
};